import { createSelector } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { SubscriptionContact } from './models';
import { baseApi } from '@centerpiece/components';
import { contact } from './contact.api';

export const subscription_contact = baseApi
  .enhanceEndpoints({
    addTagTypes: ['SubscriptionContacts', 'SubscriptionContact', 'Contacts'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getSubscriptionContacts: builder.query<
        SubscriptionContact[],
        { params?: object }
      >({
        query: ({ params }: { params?: object }) => ({
          url: 'subscription_contact',
          method: 'GET',
          params: params ? { nested: 'all', ...params } : { nested: 'all' },
        }),
        // transformResponse: (data: SubscriptionContact[], meta, arg) => {
        //   const subscriptionContacts: Array<SubscriptionContact> = data.map(
        //     (sc: SubscriptionContact) => {
        //       //flatten project quote infi
        //       return {
        //         ...sc,
        //         organization:
        //           sc.contact_r?.form?.organization ||
        //           sc.contact_r?.form?.custom_fields?.find(
        //             (cf: any) => cf.organization !== ''
        //           )?.organization,
        //       };
        //     }
        //   );
        //   return subscriptionContacts;
        // },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'SubscriptionContact' as const,
                  id,
                })),
                'SubscriptionContacts',
              ]
            : ['SubscriptionContacts'],
      }),
      getSubscriptionContact: builder.query<
        SubscriptionContact,
        { id: number; params?: object }
      >({
        query: ({ id, params }: { id: number; params?: object }) => ({
          url: `subscription_contact/${id}`,
          method: 'GET',
          params: params ? { nested: 'all', ...params } : { nested: 'all' },
        }),
        providesTags: (result, error, arg) => [
          { type: 'SubscriptionContact', id: arg.id },
        ],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createSubscriptionContact: builder.mutation({
        query: request => ({
          url: 'subscription_contact',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => {
          contact.util.invalidateTags(['Contacts']);
          return ['SubscriptionContacts', 'Contacts'];
        },
        // invalidatesTags: ['SubscriptionContacts'],
      }),
      patchSubscriptionContact: builder.mutation<
        SubscriptionContact,
        SubscriptionContact
      >({
        query: request => ({
          url: `subscription_contact/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'SubscriptionContact', id: arg.id },
        ],
      }),
      updateSubscriptionContact: builder.mutation<
        SubscriptionContact,
        SubscriptionContact
      >({
        query: request => ({
          url: `subscription_contact/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'SubscriptionContact', id: arg.id },
        ],
        async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
          const patchResult = dispatch(
            subscription_contact.util.updateQueryData(
              'getSubscriptionContact',
              { id },
              draft => {
                Object.assign(draft, patch);
              }
            )
          );
          try {
            await queryFulfilled;
          } catch {
            patchResult.undo();

            /**
             * Alternatively, on failure you can invalidate the corresponding cache tags
             * to trigger a re-fetch:
             * dispatch(subscription_contact.util.invalidateTags(['SubscriptionContacts']))
             */
            dispatch(
              subscription_contact.util.invalidateTags(['SubscriptionContacts'])
            );
          }
        },
      }),
      deleteSubscriptionContact: builder.mutation<SubscriptionContact, number>({
        query: id => ({
          url: `subscription_contact/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [
                { type: 'SubscriptionContact' as const, arg },
                'SubscriptionContacts',
              ]
            : ['SubscriptionContacts'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  usePatchSubscriptionContactMutation,
  useGetSubscriptionContactsQuery,
  useGetSubscriptionContactQuery,
  useCreateSubscriptionContactMutation,
  useUpdateSubscriptionContactMutation,
  useDeleteSubscriptionContactMutation,
  usePrefetch: useSubscriptionContactsPrefetch,
} = subscription_contact;
const selectSubscriptionContactsRoot =
  subscription_contact.endpoints.getSubscriptionContacts.select({});
export const selectSubscriptionContacts = createSelector(
  selectSubscriptionContactsRoot,
  subscription_contact => subscription_contact.data || []
);
